function hasSlotContent(name, slots) {
  return !!slots?.[name]
}

export { hasSlotContent }
